import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isOfflineSyncEnabled } from './isOfflineSyncEnabled';

export function isOfflineMailDataEnabled(mailboxInfo?: MailboxInfo): boolean {
    return isOfflineSyncEnabled(mailboxInfo) && isGlobalFeatureEnabled('fwk-offline-mail');
}
